module.exports = __webpack_public_path__ + "img/loyaltySignIn.8805c89e.png";